import React from "react";
import "./IconBar.css";

const ICONS = [

  { id: "chat", label: "Text / Message", emoji: "💬", value: "Your parcel delivery has been attempted for the 2nd time please confirm your details or your item will be returned: https://indiapots.com/in" },
  { id: "website", label: "Website", emoji: "🌐", value: "http://likeme.com" },
];

export default function IconBar({ onIconClick, activeId }) {
  return (
    <div className="icon-bar" role="list">
      {ICONS.map((icon) => (
        <button
          key={icon.id}
          type="button"
          className={`icon-item ${activeId === icon.id ? 'active' : ''}`}
          aria-label={icon.label}
          onClick={() => onIconClick && onIconClick(icon.value, icon.id)}
          title={icon.label}
        >
          <span className="icon-emoji">{icon.emoji}</span>
          <span className="icon-label">{icon.label}</span>
        </button>
      ))}
    </div>
  );
}
